import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MerchantService } from 'src/app/services/merchant/merchant.service';
import { AuthService } from 'src/app/services/auth/auth.service';

/**
 * LOS CONTACTOS DE UN COMERCIO — pantalla propia, en
 * `console/merchants/:code/contactos`.
 *
 * 🔴 Era la pestaña `contactos` de la ficha del comercio, la más chica de las
 * siete: una tabla de tres columnas con quién atiende del lado del comercio.
 *
 * ⚠️ Los contactos NO se cargan aquí: vienen dentro del propio comercio
 * (`GET /api/merchant/:code`, campo `contacts`) y se editan en el formulario
 * del comercio, que es donde se guardan. Esta pantalla los muestra, nada más —
 * por eso tampoco tiene filtros ni escribe nada en la dirección.
 */
@Component({
  selector: 'app-comercios-contactos',
  templateUrl: './comercios-contactos.component.html',
  styleUrls: ['./comercios-contactos.component.css']
})
export class ComerciosContactosComponent implements OnInit {

  codigo = '';
  comercio: any = null;

  cargando = true;
  noEncontrado = false;

  constructor(
    private ruta: ActivatedRoute,
    private _merchant: MerchantService,
    public _auth: AuthService
  ) { }

  ngOnInit(): void {
    this.ruta.paramMap.subscribe(p => {
      this.codigo = p.get('code') || '';
      this.cargar();
    });
  }

  puede = (accion: string): boolean => this._auth.hasAnyPermission([`config.comercios.${accion}`, `config.comercios_contactos.${accion}`]);

  cargar = async (): Promise<void> => {
    this.cargando = true;
    this.noEncontrado = false;
    try {
      const rep = await this._merchant.getMerchant(this.codigo);
      this.comercio = rep?.merchant || null;
      this.noEncontrado = !this.comercio;
    } catch {
      this.comercio = null;
      this.noEncontrado = true;
    } finally {
      this.cargando = false;
    }
  };

  get contactos(): any[] { return this.comercio?.contacts || []; }
}
